import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Loader from '@components/common/Loader';
import DocusignService from '@services/DocusignService';
import '@styles/metlife-iia/loader.scss';

// The page DocuSign returns the signing iframe to once the ceremony ends (signed, cancelled,
// declined, ID check failed, timed out).
//
// We supply `message` and `type`; DocuSign appends its own `event` param on the way back.
const HANDLED_SIGNER_EVENTS = new Set(Object.values(DocusignService.SIGNER_EVENTS));

function DocusignReturn() {
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type') || 'bricks';
  const message = searchParams.get('message');
  const event = searchParams.get('event');

  useEffect(() => {
    // The `window.parent !== window` check guards against direct top-level navigation to this
    // public route — there is no parent frame to notify in that case.
    if (event && HANDLED_SIGNER_EVENTS.has(event) && window.parent !== window) {
      window.parent.postMessage(
        { type: DocusignService.SIGNER_EVENT_MESSAGE_TYPE, event },
        window.location.origin,
      );
    }
  }, [event]);

  return (
    <div className="loader-page">
      <Loader
        loader={type}
        message={message}
      />
    </div>
  );
}

export default DocusignReturn;

// Copyright © 2026 Micruity Inc.
